if (!customElements.get('reef-sticky-atc')) {
  customElements.define(
    'reef-sticky-atc',
    class ReefStickyAtc extends HTMLElement {
      connectedCallback() {
        if (this.closest('quick-add-modal, product-modal')) {
          this.remove();
          return;
        }
        this.sectionId = this.dataset.sectionId;
        this.button = this.querySelector('[data-reef-sticky-button]');
        this.priceEl = this.querySelector('[data-reef-sticky-price]');
        this.mq = window.matchMedia('(max-width: 749px)');
        this.visible = false;
        this.ticking = false;

        this.button.addEventListener('click', () => {
          const target = this.getTarget();
          if (target && !target.disabled) target.click();
        });

        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.ticking = false;
            this.update();
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });

        // Variant changes re-render the price and toggle the main button in place.
        this.mirror = new MutationObserver(() => this.sync());
        const section = this.getSection();
        if (section) this.mirror.observe(section, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] });

        this.sync();
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        if (this.mirror) this.mirror.disconnect();
        this.setVisible(false);
      }

      getSection() {
        return document.getElementById(`MainProduct-${this.sectionId}`) || this.parentElement;
      }

      getTarget() {
        if (this.hasAttribute('data-quote-only')) {
          const section = this.getSection();
          return section && section.querySelector('[data-reef-request-quote]');
        }
        return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      }

      sync() {
        const target = this.getTarget();
        if (!target) return;
        if (!this.hasAttribute('data-quote-only')) {
          const label = target.querySelector('span');
          const text = label ? label.textContent.trim() : '';
          if (text && this.button.textContent.trim() !== text) this.button.textContent = text;
          if (this.button.disabled !== target.disabled) this.button.disabled = target.disabled;
        }
        if (this.priceEl) {
          const price = document.querySelector(`#price-${this.sectionId} .price-item--regular`);
          const text = price ? price.textContent.trim() : '';
          if (text && this.priceEl.textContent !== text) this.priceEl.textContent = text;
        }
      }

      update() {
        const target = this.getTarget();
        const show = this.mq.matches && !!target && target.getBoundingClientRect().bottom < 0;
        if (show !== this.visible) this.setVisible(show);
      }

      setVisible(show) {
        this.visible = show;
        this.classList.toggle('is-visible', show);
        this.toggleAttribute('inert', !show);
        this.setAttribute('aria-hidden', String(!show));
        this.liftMerchantBadge(show);
      }

      // The Google merchant badge sets its offset inline with !important, so it can only be moved inline.
      liftMerchantBadge(lift) {
        const badge = document.getElementById('google-merchantwidget-iframe-wrapper');
        if (!badge) return;
        if (lift) {
          if (this.badgeBottom === undefined) this.badgeBottom = badge.style.getPropertyValue('bottom') || '30px';
          badge.style.setProperty('bottom', `calc(${this.badgeBottom} + ${this.offsetHeight}px)`, 'important');
        } else if (this.badgeBottom !== undefined) {
          badge.style.setProperty('bottom', this.badgeBottom, 'important');
        }
      }
    }
  );
}
